import { HttpClient } from '@core/gateways'
import { UnexpectedError, ValidationError } from '@core/models/errors'
import { setupIntranetV2ApiClient } from '@core/proxies/apis/intranet-v2'
import { HttpStatusCode } from '@core/types/gateways'
import {
  AutorizaTransitoLanche,
  ObterTransitoStats
} from '@core/types/services'

const getValidationErrors = (body: any): string[] => {
  if (Array.isArray(body?.errors)) {
    return body.errors
  }

  if (Array.isArray(body?.erros)) {
    return body.erros
  }

  if (typeof body?.message === 'string') {
    return [body.message]
  }

  if (typeof body?.mensagem === 'string') {
    return [body.mensagem]
  }

  return ['Trânsito não autorizado.']
}

export const autorizaTransitoLanche: AutorizaTransitoLanche = async ({
  numeroCartao,
  pessoaId
}) => {
  const response = await HttpClient.of(setupIntranetV2ApiClient()).request({
    url: `/restaurante/transito-lanche`,
    method: 'POST',
    body: {
      numero_cartao: numeroCartao,
      pessoa_id: pessoaId
    }
  })

  switch (response.statusCode) {
    case HttpStatusCode.ok:
      return response.body
    case HttpStatusCode.badRequest:
      throw new ValidationError(getValidationErrors(response.body))
    case HttpStatusCode.unauthorized:
      throw new UnexpectedError(
        'Sessão expirada ou inválida. Faça login novamente.'
      )
    case HttpStatusCode.forbidden:
      throw new UnexpectedError(
        'Você não tem permissão para realizar esta ação.'
      )
    default:
      throw new UnexpectedError(
        'Erro inesperado ao registrar trânsito. Tente novamente ou contate o administrador.'
      )
  }
}

export const obterTransitoStats: ObterTransitoStats = async () => {
  const response = await HttpClient.of(setupIntranetV2ApiClient()).request({
    url: '/restaurante/transito-lanche/hoje',
    method: 'GET'
  })

  switch (response.statusCode) {
    case HttpStatusCode.ok:
      return response.body
    case HttpStatusCode.unauthorized:
      throw new UnexpectedError(
        'Sessão expirada ou inválida. Faça login novamente.'
      )
    case HttpStatusCode.forbidden:
      throw new UnexpectedError(
        'Você não tem permissão para visualizar os trânsitos de hoje.'
      )
    default:
      throw new UnexpectedError(
        'Não foi possível carregar os trânsitos de hoje. Tente novamente ou contate o administrador.'
      )
  }
}
